import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonHelperService } from 'src/app/core/utilities/common-helper/common-helper.service';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent implements OnInit {
  darkMode: boolean;
  isMobile: any;

  constructor( private commonHelper: CommonHelperService, private activatedRouter: ActivatedRoute, private router: Router,) { 
    this.darkMode = this.commonHelper.isDarkEnabled();
    this.isMobile = this.activatedRouter.snapshot.queryParamMap.get('isMobile');
  }

  ngOnInit(): void {
  }

  back(){
    this.router.navigate(['/settings']);
  }

}
